import { isFieldFilled } from "@helpers/isFieldFilled";
import { allFormFieldsFilled } from "@helpers/validation";
import type { BusinessInfoFieldsType } from "@shared/components/Fields/BusinessInfoFields/BusinessInfoFields";
import type { PersonalInfoFieldsType } from "@shared/components/Fields/PersonalInfoFields/PersonalInfoFields";
import type { AddressInformationData, BankAccountInfoFieldValues } from "@shared/types/fields";
import { BusinessTypes } from "@shared/types/fields/businessTypes";

export const isBusinessInfoValid = (data: BusinessInfoFieldsType, isUS: boolean): boolean => {
  const { accountType, businessName, employerId } = data ?? {};

  if (!accountType) return false;
  if (accountType === BusinessTypes.INDIVIDUAL) return true;
  if (accountType === BusinessTypes.SOLEPROPRIETOR) return isFieldFilled(businessName);

  if (accountType === BusinessTypes.LIMITEDLIABILITYCOMPANY) {
    return (
      isFieldFilled(businessName) &&
      isFieldFilled(employerId) &&
      isClassificationFieldValid(data.classification, isUS)
    );
  }

  if (
    [
      BusinessTypes.LLCSINGLEMEMBER,
      BusinessTypes.CORPORATION,
      BusinessTypes.SCORPORATION,
      BusinessTypes.CCORPORATION,
      BusinessTypes.PARTNERSHIP,
      BusinessTypes.NONPROFIT,
      BusinessTypes.TRUSTESTATE,
    ].includes(accountType as BusinessTypes)
  ) {
    return isFieldFilled(businessName) && isFieldFilled(employerId);
  }

  return false;
};

const isClassificationFieldValid = (data: string, isUS: boolean): boolean => {
  if (!isUS) return true;

  return isFieldFilled(data);
};

export const isPersonalInfoValid = (data: PersonalInfoFieldsType): boolean => {
  const optionalKeys = ["firstName", "lastName"];

  return Object.entries(data).every(
    ([key, value]) =>
      optionalKeys.includes(key) || (value !== "" && value !== null && value !== undefined)
  );
};

export const isBankAccountInfoValid = (data: BankAccountInfoFieldValues): boolean => {
  return allFormFieldsFilled(data);
};

export const isAddressInfoValid = (data: AddressInformationData): boolean => {
  const { streetAddress2: unusedStreetAddress2, ...requiredValues } = data || {};

  return allFormFieldsFilled(requiredValues);
};
